/* eslint-disable no-param-reassign */
import produce from 'immer';

import { LOAD_DRIVER_REQUEST, RESET_DRIVER_REQUEST } from '../actions/driverActions';


const initialState = {
  drivers: {}
};

const driverReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOAD_DRIVER_REQUEST:
    case RESET_DRIVER_REQUEST: {
      const { drivers } = action.payload;
      return produce(state, (draft) => {
        draft.drivers = drivers;
      });
    }

    default: {
      return state;
    }
  }
};

export default driverReducer;
